import { Directive, ViewContainerRef, Input } from '@angular/core';

@Directive({
  selector: '[app-AffichePrimeDirective]'
})
export class CompoAfficheprimeDirective {
private data:any
@Input('app-AffichePrimeDirective') set CompoAfficheprimeDirective(data:any){
  //récupération de la data de l'hote
  this.data=data
}
  constructor(public viewContainerRef:ViewContainerRef) { 
    
  }

}
